// Lib
import { useState, useRef, useCallback } from 'react';

const useMouseHoverEnabledProperty = (hoverDelay) => {
    const [enabled, setEnabled] = useState(false);
    const mouseEventTimeoutRef = useRef();

    /**
     * Wait for the delay to finish before enabling the pointer events.
     */
    const onMouseEnter = useCallback(() => {
        if (mouseEventTimeoutRef.current) clearTimeout(mouseEventTimeoutRef.current);

        mouseEventTimeoutRef.current = setTimeout(() => {
            setEnabled(true);
        }, hoverDelay);
    }, []);

    /**
     * Immediately disable the pointer events.
     */
    const onMouseLeave = useCallback(() => {
        if (mouseEventTimeoutRef.current) clearTimeout(mouseEventTimeoutRef.current);

        setEnabled(false);
    }, []);

    return [enabled, onMouseEnter, onMouseLeave];
};

export default useMouseHoverEnabledProperty;
